module.exports = __webpack_public_path__ + "img/icon-faces-mew.7b784ab3.svg";